<script setup lang="ts">
defineOptions({
	name: 'FinalProvisionsSection',
})

const { t: $t, locale } = useI18n()
const { $tThird } = useNuxtApp()

const firstHtml = computed(() => {
	return $tThird(
		'These {terms}, along with its Privacy Policy, constitute the complete legal agreement between {users} and {company}, governing {users_more} access to and use of the {platform}. They supersede any prior or contemporaneous agreements, whether oral or written, between {users} and {company} regarding the use of the {platform}.',
		{
			users: `<span class="font-semibold">${locale.value === 'fr' ? $t('the User') : $t('Users')}</span>`,
			terms: `<span class="font-semibold">${$t('Terms & Conditions')}</span>`,
			users_more: `<span class="font-semibold">${$t('Users’')}</span>`,
			company: '<span class="font-semibold">Gaveta Decimal</span>',
			platform: `<span class="font-semibold">${$t('Platform')}</span>`,
		},
	)
})

const secondHtml = computed(() => {
	return $tThird('These {terms} do not confer rights or remedies upon any person or entity other than {users}.', {
		users: `<span class="font-semibold">${locale.value === 'fr' ? $t('the User') : $t('Users')}</span>`,
		terms: `<span class="font-semibold">${$t('Terms & Conditions')}</span>`,
	})
})

const thirdHtml = computed(() => {
	return $tThird(
		'The language in these {terms_conditions} will be interpreted based on its fair meaning and not strictly in favour of or against any party.',
		{
			terms_conditions: `<span class="font-semibold">${$t('Terms & Conditions')}</span>`,
		},
	)
})

const fourthHtml = computed(() => {
	return $tThird(
		'If any part of these {terms} is found to be invalid, illegal, void, or unenforceable, that portion will be considered severed from these {terms} and will not affect the validity or enforceability of the remaining provisions.',
		{
			terms: `<span class="font-semibold">${$t('Terms & Conditions')}</span>`,
		},
	)
})

const fivethHtml = computed(() => {
	const company = '<span class="font-semibold">Gaveta Decimal</span>'
	return $tThird(
		'{companies} failure or delay in exercising or enforcing any right or provision in these {terms_conditions} will not be seen as a waiver of the future exercise or enforcement of such right or provision. Waivers of any right or provision in these {terms_conditions} will only be effective if in writing and signed by a duly authorised representative on behalf of {company}.',
		{
			companies: locale.value !== 'en' ? company : '<span class="font-semibold">Gaveta Decimal’s</span>',
			company,
			terms_conditions: `<span class="font-semibold">${$t('Terms & Conditions')}</span>`,
		},
	)
})

const sixthHtml = computed(() => {
	return $tThird(
		'All matters related to these {terms} will be governed by and construed in accordance with the laws of Portugal, without consideration of any choice or conflict of law provision or rule.',
		{
			terms: `<span class="font-semibold">${$t('Terms & Conditions')}</span>`,
		},
	)
})

const seventhHtml = computed(() => {
	return $tThird(
		'Before resorting to litigation in a judicial court, {company} and {users} agree to resolve any disputes, claims, or controversies arising out of or relating to these {terms} through binding arbitration, in accordance with the rules of a recognised Portuguese arbitration centre mutually agreed upon by {company} and {users_low}, conducted in the English language.',
		{
			users: `<span class="font-semibold">${locale.value === 'fr' ? $t('the User') : $t('Users')}</span>`,
			users_low: `<span class="font-semibold">${locale.value === 'fr' ? $t('the User') : $t('Users')}</span>`,
			company: '<span class="font-semibold">Gaveta Decimal</span>',
			terms: `<span class="font-semibold">${$t('Terms & Conditions')}</span>`,
		},
	)
})

const eighthHtml = computed(() => {
	return $tThird(
		'If the arbitration process described above becomes unavailable, cannot proceed, or fails to resolve the matter at hand, {company} and {users} hereby irrevocably submit to the exclusive jurisdiction of the District Courts of Lisbon for the resolution of any such disputes, and expressly waive any right to bring proceedings in any other court or jurisdiction.',
		{
			users: `<span class="font-semibold">${locale.value === 'fr' ? $t('the User') : $t('Users')}</span>`,
			company: '<span class="font-semibold">Gaveta Decimal</span>',
		},
	)
})

const ninthHtml = computed(() => {
	return $tThird(
		'{users} may not assign any of their rights or obligations under these {terms} without the prior written consent of {company}, whether by operation of law or otherwise. {company} may, at its sole discretion, assign its rights and obligations under these {terms} to an affiliate or in connection with an acquisition, sale, or merger.',
		{
			users: `<span class="font-semibold">${locale.value === 'fr' ? $t('the User') : $t('Users')}</span>`,
			company: '<span class="font-semibold">Gaveta Decimal</span>',
			terms: `<span class="font-semibold">${$t('Terms & Conditions')}</span>`,
		},
	)
})
</script>

<template>
	<section class="space-y-7">
		<div class="flex items-center gap-3.5">
			<UIcon
				name="mdi:check-decagram-outline"
				class="size-7 text-[#ED8B00]"
			/>
			<h2 class="text-xl sm:text-2xl font-medium text-gray-900 tracking-tight">
				{{ $t('Final Provisions') }}
			</h2>
		</div>
		<div class="space-y-5 text-base sm:text-[18px] text-[#364153] tracking-[-0.199px] leading-7">
			<p v-html="firstHtml"></p>
			<p v-html="secondHtml"></p>
			<p v-html="thirdHtml"></p>
			<p v-html="fourthHtml"></p>
			<p v-html="fivethHtml"></p>
			<p v-html="sixthHtml"></p>
			<p v-html="seventhHtml"></p>
			<p v-html="eighthHtml"></p>
			<p v-html="ninthHtml"></p>
			<p>
				{{
					$tThird('If Users have any questions or comments, they should contact Gaveta Decimal at {email}.', {
						email: 'hello@lucky-wise.com',
					})
				}}
			</p>
			<p class="text-right pt-10 text-base italic">{{ $t('Date of last update: 18 November 2025') }}</p>
		</div>
	</section>
</template>
